const ProductVariants = ({ product, variantSelect, setVariantSelect }) => {
    return (
        <div className="option mb-8">
            {product?.sale_props?.map((prop, key) => (
                <div key={key}>
                    <label className="form-label fw-bold text-capitalize mb-4">
                        <b>{prop.prop_name}:</b>
                    </label>
                    <div className="fr-choose-variant fs-15 fw-semibold mb-2 d-flex gap-4 flex-wrap">
                        {prop?.sale_prop_values?.map((v, k) => (
                            <button
                                type="button"
                                className={`btn btn-secondary ${variantSelect === v.prop_value_id ? "active" : ""}`}
                                data-container="body"
                                data-toggle="popover"
                                data-placement="top"
                                onClick={() => setVariantSelect(v.prop_value_id)}
                                key={k}
                            >
                                {v.prop_value}
                            </button>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProductVariants;
